//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Button from '@/components/Shared/Button.vue'
export default {
  components: {
    Button,
  },
  props: {
    selectedUsers: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false,
    }
  },
  mounted() {
    this.resize()
    window.addEventListener('resize', this.resize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resize)
  },
  methods: {
    resize() {
      this.isExpanded = window.innerWidth <= 435
    },
  },
}
